import { withCompInfo } from '@wix/editor-elements-integrations'
import { WRichTextCSSVars } from './WRichText'
import { getMobileScaledFont } from '@wix/thunderbolt-becky-root'
import _ from 'lodash'

export const css = withCompInfo<WRichTextCSSVars, any>()(
	[
		'compProps',
		'styleProperties',
		'compLayout',
		'isMobileView',
		'hasResponsiveLayout',
		'experiments',
		// @ts-ignore - Remove once siteFonts is added to the compInfo
		'siteFonts',
		// @ts-ignore - Remove once siteFontsSpxResolved is added to the compInfo
		'siteFontsSpxResolved',
	],
	({
		compProps,
		styleProperties,
		compLayout,
		isMobileView,
		hasResponsiveLayout,
		experiments,
		// @ts-ignore - Remove once siteFonts is added to the compInfo
		siteFonts,
		// @ts-ignore - Remove once siteFontsSpxResolved is added to the compInfo
		siteFontsSpxResolved,
	}) => {
		const { packed, verticalText, minHeight, minWidth } = compProps
		const { height, width, scale, rotationInDegrees } = compLayout
		// TODO: When moving this code to editor-elements this logic should be done using previewMapper
		const isMobilePreview = isMobileView && process.env.PACKAGE_NAME === 'thunderbolt-ds'
		const isPacked = packed || isMobilePreview

		const isSupportSpOn = experiments['specs.thunderbolt.supportSpxInEEMappers']
		// Use resolved spx font map whenever applicable
		const fontMap = isSupportSpOn ? siteFontsSpxResolved : siteFonts

		/*
		 ** TODO: Parse html from compData and get only used fonts/colors
		 */
		const scaledFonts =
			scale !== 1
				? _.chain(fontMap)
						.mapValues((font: string, _key: string) => {
							return isMobileView ? getMobileScaledFont(font, scale!) : font
						})
						.mapKeys((_value, key) => `--${key}`)
						.value()
				: {}

		const resolveMinSize = (minSizeKey: number, sizeKey: number) =>
			isPacked ? minSizeKey : isMobileView ? sizeKey : minSizeKey || sizeKey

		/**
	   The minSize value is calculated by the following conditions (the example is for height, but same for width):
			if packed & mobile => 'min-height': 0
			if packed & !mobile => 'min-height': minHeight
			if !packed & mobile => 'min-height': height
			if !packed & !mobile => 'min-height': minHeight || height
	 */
		const minSizeCssValue =
			!rotationInDegrees &&
			!hasResponsiveLayout &&
			!(isPacked && isMobileView) &&
			resolveMinSize(verticalText ? minWidth : minHeight, (verticalText ? width : height)!)

		const minSizeCss = !minSizeCssValue
			? {}
			: verticalText
			? { 'min-width': `${minSizeCssValue}px` }
			: { '--min-height': `${minSizeCssValue}px` }

		const sizeCss =
			!hasResponsiveLayout &&
			(verticalText
				? // TODO: remove this once catharsis compMeasures experiment is merged, this logic will be handled with https://github.com/wix-private/thunderbolt/pull/27160
				  !(styleProperties.overflowX === 'hidden') && { width: 'auto' }
				: !(styleProperties.overflowY === 'hidden') && { height: 'auto' })

		const textDirection = styleProperties.direction ? { '--text-direction': styleProperties.direction } : {}

		return { ...scaledFonts, ...minSizeCss, ...sizeCss, ...textDirection }
	}
)
